(function () {
  // Bruk global jQuery
  var $ = window.jQuery;

  function CurrentOffers() { this.init(); }

  CurrentOffers.prototype.init = function () {
    var section = document.querySelector('[data-current-offers]');
    if (!section) return;

    var toggle = section.querySelector('[data-toggle]');
    var productToggle = document.querySelector('[data-product-page-current-offers]');
    var content = section.querySelector('[data-content]');
    var buttons = section.querySelector('[data-slider-buttons]');
    var $tint = $('[data-current-offers-tint]');

    // Hvis vi ikke har nødvendig markup, avbryt
    if (!content || !$tint.length) return;

    // Samle knapper som styrer samme panel
    var toggles = [toggle, productToggle].filter(Boolean);

    // Én felles funksjon for å åpne/lukke
    function setOpen(open) {
      if (open) {
        toggles.forEach(function (btn) { btn.classList.add('active'); });
        $tint.addClass('active');
        $(content).stop(true).animate({ height: '100%' }, 300);
        if (buttons) $(buttons).show();
        if (window.zE) window.zE('messenger:set', 'zIndex', 999998);
      } else {
        toggles.forEach(function (btn) { btn.classList.remove('active'); });
        $tint.removeClass('active');
        $(content).stop(true).animate({ height: 0 }, 300);
        if (buttons) $(buttons).hide();
        if (window.zE) window.zE('messenger:set', 'zIndex', 999999);
      }
    }

    // Klikk-handlere for begge knapper (samme logikk)
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = !btn.classList.contains('active');
        setOpen(willOpen);
      });
    });

    // Tint lukker alt
    $tint.on('click', function () {
      setOpen(false);
    });

    // Koble Magnific Popup én gang hvis tilgjengelig
    if ($ && $.fn && $.fn.magnificPopup) {
      $(section).find('[data-toggle-details]').magnificPopup({
        type: 'inline',
        midClick: true,
        mainClass: 'my-mfp-zoom-in'
      });
    }
  };

  function boot() {
    if (document.querySelector('[data-current-offers]')) new CurrentOffers();
  }

  // Init ved første load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Init ved seksjons-endringer i Shopify-editor
  document.addEventListener('shopify:section:load', function () {
    if (document.querySelector('[data-current-offers]')) new CurrentOffers();
  });
})();
